import SliderData from "./SliderData";
import ColorizeSlider from "./ColorizeSlider";

interface SliderProps {
    min: number;
    blocks: {
        value: number;
        color: string;
    }[],
    roundValues: boolean;
    indicatorColor: string;
    sliderWidth?: number;
    hiddenInputsOutsideMinMax: boolean;
    unit: string;
    make_smooth_numbers: boolean;
}

interface sliderTelematicsCallbacks {
    // false === infinity
    onSliderChange: (currentValue1: number | false, currentValue2: number | false) => void;
}

export class sliderTelematicsColorize {

    private root: HTMLDivElement;
    private props: SliderProps;
    private callbacks: sliderTelematicsCallbacks;
    private colorizeSlider: ColorizeSlider | null;
    private sliderData: SliderData;

    constructor(root: HTMLDivElement, props: SliderProps, callbacks: sliderTelematicsCallbacks) {
        this.root = root;
        this.props = props;
        this.callbacks = callbacks;
        this.colorizeSlider = null;
        this.sliderData = null;

        if (this.props.blocks.length === 0) {
            this.props.blocks = [
                {
                    value: this.props.min,
                    color: '#000000'
                },
                {
                    value: this.props.min + 1,
                    color: '#ffffff'
                }
                ];
        }
        
        let min: number = this.props.min;
        let max: number = this.props.blocks[this.props.blocks.length - 1].value ?? min;
        this.sliderData = (new SliderData())
            .setSliderWidth(this.props.sliderWidth ?? 600)
            .setSliderHeight(30)
            .setMinimum(min)
            .setVisibleMinMax(min, max)
            .allowOutsideExtremumValues(false)
            .setAllowMinMaxSymbols(false)
            .setUnit(this.props.unit)
            .setRoundValues(this.props.roundValues)
            .setMakeSmoothNumbers(this.props.make_smooth_numbers);
        
        // console.debug('sliderTelematicsColorize, unit1: ', this.props.unit);
        // console.debug('sliderTelematicsColorize, props: ', this.props);

        this.props.blocks.forEach((block) => {
            this.sliderData.addBlock(block.value, block.color);
        });

        this.colorizeSlider = new ColorizeSlider(this.sliderData, {
            enableAddRemovePeriods: true,
            enableColorPicker: true,
            darkMode: true,
            sliderMode: 'colorize',
            smallInputs: false,
            inputsAboveSlider: false,
            enableSmartRounding: true,
            periodMode: false,
            indicatorColor: this.props.indicatorColor,
        }, {
            onSliderChange: (sliderData: SliderData) => {
                // console.log('updateDraggableElement');
                // this.callbacks.onSliderChange();
            },
            onSliderDragMove: (sliderData: SliderData) => {
                this.colorizeSlider.reloadSVGBackground();
            }
        });

        this.root.innerHTML = '';
        this.root.appendChild(
            this.colorizeSlider.getSlider()
        );
    }


    getSlider(): ColorizeSlider   {
        return this.colorizeSlider;
    }

    getSliderData(): SliderData   {
        return this.sliderData;
    }

    // setSliderData(sliderData: SliderData) {
    //     this.sliderData.load(sliderData.getSliderData());
    // }

    reload(makeSmoothNumber: boolean | null = null): boolean {
        if (makeSmoothNumber !== null) {
            this.getSliderData().data.make_smooth_numbers = makeSmoothNumber;
        }
        // console.debug('getQuantile, reload, this.sliderData', this.sliderData.getVisibleMin(), this.sliderData.getVisibleMax());
        return this.getSlider().reload();
    }

}
